import { Card, Collapse, Divider, Grid, Switch } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import deviceAPI from "api/bks";
import Swal from "sweetalert2";
import { TransitionGroup } from "react-transition-group";
import { useNavigate } from "react-router-dom";

function DeviceSettingsForm({ selected_device, sites, selected_group, selected_subgroup = null, groups }) {

    const formRef = useRef(null);
    const { mutate } = useMutation({
        mutationFn: (values) => deviceAPI.updateDeviceData(values)
    })

    const navigate = useNavigate();

    const [deviceData, setDeviceData] = useState({
        uuid: selected_device.uuid,
        name: selected_device.name,
        position: selected_device.position,
        active: selected_device.active,
        serial_number: selected_device.serial_number,
        site_id: selected_device.site_id
    });

    const [groupValue, setGroupValue] = useState(selected_group ? selected_group.group_id : null);
    const [subgroupValue, setSubgroupValue] = useState(selected_subgroup ? selected_subgroup.group_id : null);
    const [siteIdValue, setSiteIdValue] = useState(selected_device.site_id == 'undefined' ? null : selected_device.site_id);

    const defaultValues = {
        uuid: selected_device.uuid,
        name: selected_device.name,
        position: selected_device.position,
        active: selected_device.active,
        serial_number: selected_device.serial_number,
        site_id: selected_device.site_id
    }
    // console.log(defaultValues)

    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm({
        defaultValues: defaultValues
    });

    const triggerFormSubmit = () => {
        formRef.current.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    }

    async function submitForm(formData) {
        // console.log('formData1: ', formData);
        formData.active = deviceData.active;
        formData.site_id = siteIdValue;
        formData.group_id = subgroupValue != null ? subgroupValue : groupValue;
        formData.uuid = selected_device.uuid;
        // console.log('formData2: ', formData);

        await Swal.fire({
            icon: "success",
            title: `<div style="font-family:Roboto,Helvetica,Arial,sans-serif; font-weight:500; font-size:28px">Saved!</div>`,
            showConfirmButton: false,
            timer: 2000
        }).then((result) => {
            mutate(formData);
            // navigate(0);
        });
    }

    function updateValues(field, new_value) {
        // console.log(field, new_value)

        var new_data = deviceData;
        if (field == 'group') {
            setGroupValue(new_value);
            setSubgroupValue(null);
        }
        else if (field == 'subgroup') {
            setSubgroupValue(new_value);
        }
        else if (field == 'site_id'){
            setSiteIdValue(new_value);
        }
        else {
            new_data[field] = new_value;
        }
        // console.log(new_data);

        setDeviceData(new_data);
    }

    function applyValues(field) {
        return {
            "value": deviceData[field],
            "onChange": (new_value) => {
                updateValues(field, new_value.target.value);
            }
        }
    }

    console.log(sites);
    sites.push({site_id: 'Not Assigned'})

    return (
        <Card id="basic-info" sx={{ overflow: "visible", height: '100%' }}>
            <form ref={formRef} onSubmit={handleSubmit((data) => { submitForm(data); })}>
                <SoftBox p={3}>
                    <SoftTypography variant="h5">Device Settings</SoftTypography>
                </SoftBox>
                <SoftBox component="form" pb={3} px={3}>
                    <Grid container spacing={3}>
                        <Grid item xxs={12} lg={4}>
                            <SoftBox pl={1} my={0.5}>
                                <SoftTypography variant="caption" fontWeight='bold'>E-Minor Label</SoftTypography>
                            </SoftBox>
                            <SoftBox>
                                <SoftInput placeholder="E-Minor Label" {...register('name')} />
                            </SoftBox>
                        </Grid>
                        <Grid item xxs={12} lg={4}>
                            <SoftBox pl={1} my={0.5}>
                                <SoftTypography variant="caption" fontWeight='bold'>Serial Number</SoftTypography>
                            </SoftBox>
                            <SoftBox>
                                <SoftInput placeholder="Serial Number" {...register('serial_number')} />
                            </SoftBox>
                        </Grid>
                        <Grid item xxs={12} lg={4}>
                            <Grid container>
                                <Grid item xxs={12}>
                                    <SoftTypography variant="caption" fontWeight='bold'>Active</SoftTypography>
                                </Grid>
                                <Grid item xxs={12}>
                                    <SoftBox my={1.5}>
                                        <Controller
                                            name="checkbox"
                                            control={control}
                                            defaultValue={defaultValues.active}
                                            render={({ field }) => <Switch onChange={(e) => { console.log(e.target.checked); field.onChange(e.target.checked); var new_data = deviceData; new_data['active'] = !new_data['active']; setDeviceData(new_data) }} checked={field.value == null ? defaultValues.active : field.value} />}
                                        />
                                    </SoftBox>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SoftBox py={3}>
                        <Divider />
                    </SoftBox>
                    <Grid>
                        <Grid item xxs={12} lg={4}>
                            <SoftBox my={1}>
                                <SoftBox pl={1} my={0.5}>
                                    <SoftTypography variant="caption" fontWeight='bold'>Group</SoftTypography>
                                </SoftBox>
                                <SoftBox>
                                    <Controller
                                        name="SoftSelectGroup"
                                        control={control}
                                        render={({ field }) => (
                                            <SoftSelect
                                                defaultValue={groupValue ? { value: groupValue, label: groups.filter((group) => group.group_id == groupValue)[0].name } : ''}
                                                options={groups.map(row => { return { value: row.group_id, target: { value: row.group_id }, label: row.name } })}
                                                onChange={(new_value) => { updateValues('group', new_value.target.value) }}

                                            />
                                        )}
                                    />
                                </SoftBox>
                            </SoftBox>
                        </Grid>
                        <Grid item xxs={12} lg={4}>
                            <TransitionGroup>
                                {(groupValue != null && groups.filter((group) => group.group_id == groupValue)[0].subgroups.length > 0) && (
                                    <Collapse>
                                        <SoftBox my={1}>
                                            <SoftBox pl={1} my={0.5}>
                                                <SoftTypography variant="caption" fontWeight='bold'>Subgroup</SoftTypography>
                                            </SoftBox>
                                            {subgroupValue == null && (
                                                <SoftBox>
                                                    <Controller
                                                        name="SoftSelectSubgroup"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <SoftSelect
                                                                options={groups.filter((group) => group.group_id == groupValue)[0].subgroups.map(row => { return { value: row.group_id, target: { value: row.group_id }, label: row.name } })}
                                                                onChange={(new_value) => { updateValues('subgroup', new_value.target.value) }}

                                                            />
                                                        )}
                                                    />
                                                </SoftBox>
                                            )}
                                            {subgroupValue != null && (
                                                <SoftBox>
                                                    <Controller
                                                        name="SoftSelectSubgroup"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <SoftSelect
                                                                defaultValue={{ value: subgroupValue, label: groups.filter((group) => group.group_id == groupValue)[0].subgroups.filter((subgroup) => subgroup.group_id == subgroupValue)[0].name }}
                                                                options={groups.filter((group) => group.group_id == groupValue)[0].subgroups.map(row => { return { value: row.group_id, target: { value: row.group_id }, label: row.name } })}
                                                                onChange={(new_value) => { updateValues('subgroup', new_value.target.value) }}

                                                            />
                                                        )}
                                                    />
                                                </SoftBox>
                                            )}
                                        </SoftBox>
                                    </Collapse>
                                )}
                            </TransitionGroup>
                        </Grid>
                        <Grid item xxs={12} lg={4}>
                            <TransitionGroup>
                                {((groupValue != null && groups.filter((group) => group.group_id == groupValue)[0].subgroups.length == 0) || (subgroupValue != null && groups.filter((group) => group.group_id == groupValue)[0].subgroups.length > 0)) && (
                                    <Collapse>
                                        <SoftBox my={1}>
                                            <SoftBox pl={1} my={0.5}>
                                                <SoftTypography variant="caption" fontWeight='bold'>Site ID</SoftTypography>
                                            </SoftBox>
                                            <SoftBox>
                                                <Controller
                                                    name="SoftSelectSiteID"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <SoftSelect
                                                            defaultValue={{value: selected_device.site_id, label: selected_device.site_id}}
                                                            options={sites.filter((site) => site.site_id == 'Not Assigned' || (subgroupValue == null ? site.group_id == groupValue : site.group_id == subgroupValue)).sort((a, b) => a.site_id.localeCompare(b.site_id, 'en', { numeric: true })).map(row => { return { value: row.site_id, target: { value: row.site_id }, label: row.site_id } })}
                                                            onChange={(new_value) => { updateValues('site_id', new_value.target.value) }}
                                                        />
                                                    )}
                                                />
                                            </SoftBox>
                                        </SoftBox>
                                    </Collapse>
                                )}
                            </TransitionGroup>
                        </Grid>
                    </Grid>
                </SoftBox>
                <SoftBox display='flex' flexDirection='row' justifyContent='space-between' p={3}>
                    <SoftButton variant="gradient" color="dark" onClick={() => { triggerFormSubmit(); }}>Save</SoftButton>
                </SoftBox>
            </form>
        </Card>
    );
}

DeviceSettingsForm.propTypes = {
    selected_device: PropTypes.object,
    sites: PropTypes.array,
    selected_group: PropTypes.object,
    selected_subgroup: PropTypes.object,
    groups: PropTypes.array,
};

export default DeviceSettingsForm;